import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const location = useLocation();
  const currentPath = location.pathname;
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navItems = [{
    name: 'HOME',
    path: '/'
  }, {
    name: 'ABOUT US',
    path: '/about'
  }, {
    name: 'EVENTS',
    path: '/events'
  }, {
    name: 'SERVICES',
    path: '/services'
  }, {
    name: 'OUR WORKS',
    path: '/works'
  }, {
    name: 'BLOG',
    path: '/blog'
  }];
  return <header className="fixed top-0 left-0 w-full z-50 bg-[#992f74]" data-id="element-62">
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between relative" data-id="element-63">
        {/* Logo */}
        <div className="flex items-center" data-id="element-64">
          <Link to="/" className="flex items-center gap-3" data-id="element-65">
            <img src="https://cdn.magicpatterns.com/uploads/58tNa4GTAAmpR1FoCHN2wS/Image_(57).jpg" alt="Sips & Nibblez Logo" className="h-10 w-10 md:h-12 md:w-12 rounded-full object-cover border-2 border-white/20" data-id="element-66" />
            <span className="hidden sm:inline-block lg:hidden text-white font-montserrat font-bold italic tracking-wider text-sm md:text-base" data-id="element-67">
              Sips & Nibblez
            </span>
          </Link>
        </div>

        {/* Right side container */}
        <div className="flex items-center gap-3 md:gap-8" data-id="element-68">
          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-6 xl:space-x-10" data-id="element-69">
            {navItems.map(item => {
            const isHashLink = item.path.includes('#');
            const isActive = isHashLink ? location.pathname + location.hash === item.path : currentPath === item.path || item.path !== '/' && currentPath.startsWith(item.path);
            return <a key={item.name} href={item.path} className={`relative font-montserrat text-[12px] xl:text-[14px] tracking-[0.2em] transition-colors duration-300 group py-2 ${isActive ? 'text-white font-bold' : 'text-white/80 hover:text-white'}`} data-id="element-70">
                  {item.name}
                  <span className={`absolute bottom-0 h-[2px] bg-white transition-all duration-300 ${isActive ? 'w-full left-0 opacity-100' : 'w-0 left-1/2 opacity-0 group-hover:w-full group-hover:left-0 group-hover:opacity-100'}`} data-id="element-71"></span>
                </a>;
          })}
          </nav>

          {/* Catchy Book Now Button */}
          <Link to="/book" className="bg-white text-[#992f74] px-4 py-2 md:px-6 md:py-2.5 rounded-full font-montserrat font-bold italic text-[11px] md:text-[13px] tracking-widest uppercase shadow-lg hover:bg-black hover:text-white transition-all duration-300 transform hover:scale-105 active:scale-95 whitespace-nowrap" data-id="element-72">
            Book Now
          </Link>

          {/* Mobile Hamburger Button */}
          <button className="lg:hidden text-white p-1 md:p-2 focus:outline-none" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-73">
            {isMobileMenuOpen ? <X size={24} data-id="element-74" /> : <Menu size={24} data-id="element-75" />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation Menu */}
      <AnimatePresence data-id="element-76">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="lg:hidden bg-[#992f74] border-t border-white/10 overflow-hidden" data-id="element-77">
            <nav className="flex flex-col px-6 py-4 space-y-4" data-id="element-78">
              {navItems.map(item => {
            const isHashLink = item.path.includes('#');
            const isActive = isHashLink ? location.pathname + location.hash === item.path : currentPath === item.path || item.path !== '/' && currentPath.startsWith(item.path);
            return <a key={item.name} href={item.path} onClick={() => setIsMobileMenuOpen(false)} className={`font-montserrat text-[15px] tracking-[0.2em] py-3 border-b border-white/10 last:border-none ${isActive ? 'text-white font-bold' : 'text-white/80'}`} data-id="element-79">
                    {item.name}
                  </a>;
          })}
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}